import styled from "styled-components";

export const ServiceContainer = styled.div`
    height: 800px;
    display: flex;
    flex-direction: column;
    justify-content: top;
    align-items: center;
    background: transparent;
    padding-bottom: 0%;

    @media screen and (max-width: 1478px) {
        height: 1200px;
    }
    @media screen and (max-width: 768px) {
        height: 1900px;
    }

    
`

export const ServicesWrapper = styled.div`
    max-width: 1000px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    align-items: center;
    justify-content: center;
    grid-gap: 30px;
    padding: 0 0;
    

    @media screen and (max-width: 1478px) {
        transition: 1s;
        grid-template-columns: 1fr 1fr;
    }

    @media screen and (max-width: 768px) {
        grid-template-columns: 1fr;
        padding: 0 20px;
    }
`

export const ServicesCard = styled.div`
    
    background: #000;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    border-radius: 10px;
    height: fit-content;
    width: 300px;
    padding: 0px 20px;
    padding-bottom: 20px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
    transition: all 0.2s ease-in-out;
    font-family: 'Titillium Web', sans-serif;

    &:hover {
        transform: scale(1.1);
        transition: all 0.2s ease-in-out;
        
    }
    @media screen and (max-width:1312px){
        height: fit-content;
        width: 270px;
        margin: 5% 0;
    }

    @media screen and (max-width:768px){
        background: #4C595A;
    }
`

export const ServicesIcon = styled.img`
    height: 150px;
    width: auto;
    margin-top: 15%;

    @media screen and (max-width:1312){
        height: 100px;
        width: 100px;
    }
`

export const ServiceH1 = styled.h1`
    transform: translateY(0%);
    font-size: 1.5rem;
    color: #fff;
    margin-bottom: 3%;
    text-align: center;

    @media screen and (max-width:768px) {
        margin-top: 0%;
        font-size: 1.25rem;
    }
`

export const ServicesH2 = styled.h2`
    font-size: 60px;
    color: white;
    text-align: center;
    font-family: 'Gemunu Libre', sans-serif;
    font-weight: 100;

    @media screen and (max-width:768px) {
        font-size: 2em;
    }
`

export const ServicesP = styled.p`
    font-size: 1rem;
    text-align: center;
    line-height: 1.5rem;
    color: white;
`
